import { Component, OnInit, Input } from '@angular/core';
import { TrackingTimelineResponse } from '../../../model/trackingTimelineResponse.model';
import { Step } from 'src/app/model/step.model';
import { MatDialog } from '@angular/material/dialog';
import { RechercheService } from 'src/app/services/recherche.service';
import { AtInternetService } from 'src/app/services/at-internet.service';
import { TrackingParcelRoutingService } from 'src/app/services/tracking-parcel-routing.service';
import { DeliveryMapComponent } from './delivery-map/delivery-map.component';
import { RoundInfoResponse } from 'src/app/model/round-info-response.model';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  @Input() trackingResponse: TrackingTimelineResponse;
  @Input() signingCode: string;
  @Input() lastEvent: Step;
  @Input() tag;

  deliveryLabel;
  idLastEventActive: Number;
  lastEventActive: Step;
  timelineStep: Step[];
  isSend: boolean = false;
  isSum: boolean = false;
  isNat: boolean = false;
  accountNum: string;
  confidentialCode: string = '';
  deliveryAdresse: string = '';
  showYourMap: boolean = false;
  timeSlot: string = '';
  showUnderTimeline: boolean = false;
  shortLabel4Step5: string = '';
  dateStep5: Date;
  isTousFact: boolean = false;
  responseTpr:RoundInfoResponse;

  constructor(private mapDialog: MatDialog,
  	private rechercheService: RechercheService,
    private atInternetService: AtInternetService,
    private trackingParcelRoutingService: TrackingParcelRoutingService) { }

  ngOnInit(): void {
    this.deliveryLabel = this.trackingResponse.parcel.deliveryLabel;
    this.accountNum = this.trackingResponse.parcel.contractNumber;
    if (this.trackingResponse && this.trackingResponse.parcel && this.trackingResponse.parcel.rangeHourMin 
      && this.trackingResponse.parcel.rangeHourMin.length !== 0
      && this.trackingResponse.parcel.rangeHourMax 
      && this.trackingResponse.parcel.rangeHourMax.length !== 0) {
        this.timeSlot = "entre " + this.trackingResponse.parcel.rangeHourMin.replace(":", "h") + " et " + this.trackingResponse.parcel.rangeHourMax.replace(":", "h");
    }
    if(this.trackingResponse.parcel.step) {
      this.trackingResponse.parcel.step.forEach(element => {
        if (element.stepId === 5 && element.status === 'STEP_STATUS_INACTIVE' 
        && element.date) {
          this.showUnderTimeline = true;
          this.shortLabel4Step5 = element.labelShort;
          this.dateStep5 = element.date;
        }
      });
    }
    this.deliveryAdresse = this.trackingResponse.parcel.consigneeInformation.address.address0 + ' ' +
        this.trackingResponse.parcel.consigneeInformation.address.address1 + ' ' +
        this.trackingResponse.parcel.consigneeInformation.address.address2 + ' ' +
        this.trackingResponse.parcel.consigneeInformation.address.address3 + ' ' +
        this.trackingResponse.parcel.consigneeInformation.address.zipCode + ' ' +
        this.trackingResponse.parcel.consigneeInformation.address.city;
    this.idLastEventActive = this.lastEvent.stepId;
    this.lastEventActive = this.lastEvent;
    // SQUAD7-767 : evol RG001
    let isDeliveredAtHome = (this.trackingResponse.parcel.deliveryMode && this.trackingResponse.parcel.deliveryMode==="Domicile")? true:false;
    if (isDeliveredAtHome && this.trackingResponse.parcel.event) {
        this.trackingResponse.parcel.event.forEach ( e => {
          if (e.code && ['RSDREL', 'LIVREL', 'RSTZNL', 'RENGUI', 'RSDBPI'].includes(e.code)) {
            isDeliveredAtHome=false;
          }
        });
    }
    // Fin
    //RG001 SQUAD4-5100
    if (this.trackingResponse.parcel.service.map) {
    this.trackingParcelRoutingService.getRoundInfo(this.trackingResponse.parcel.parcelUuid).subscribe(
      response => { 
        
        if (response && response.round && response.round.length != 0) {
        this.responseTpr =response;
          // squad7-700 : afficher le block carte de livraison quand round a des infos
          this.showYourMap = (this.lastEventActive.stepId===4 && this.lastEventActive.subStepId==='DISTOU' && isDeliveredAtHome)? true:false;
          
          if (this.isMobile() && this.showYourMap) {
            let openTime = Date.now();
            this.atInternetService.generateClickOpenMap(
              this.tag,
              'CTA_ouverture_carte',
              'popin_Cartographie',
              this.trackingResponse.parcel.parcelNumber
            );
            this.mapDialog.open(DeliveryMapComponent, {
              disableClose: true,
              panelClass: 'delivery-map-dialog',
              data: {
                "title": "Carte",
                "tag": this.tag,
                "openTime": openTime,
                "isTousFact": this.isTousFact,
                "deliveryAdresse" : this.deliveryAdresse,
                "parcelUuid": this.trackingResponse.parcel.parcelUuid,
                "responseTpr":this.responseTpr,
                "shipperId": this.accountNum,
              }
            });
          }
        }
    });
  }
    this.isNat = this.trackingResponse.parcel.geographicCoverage =='NAT' && (!this.trackingResponse.parcel.overSeas && !this.trackingResponse.parcel.international);
    this.timelineStep = this.trackingResponse.parcel.step.reverse().filter(oneStep => {
      if (oneStep.stepId == 0) { return false; }
      return true;
    })

    if (this.trackingResponse.parcel.deliveryMode === "Domicile" && this.trackingResponse.parcel.deliverySignature && this.trackingResponse.parcel.geographicCoverage === "NAT") {
      this.confidentialCode= this.signingCode;
    }
  }

  closeTheDeliveryBloc() {
    this.isSend = true;
  }

  callMap() {
    let openTime = Date.now();
    this.atInternetService.generateClickOpenMap(
      this.tag,
      'CTA_ouverture_carte',
      'popin_Cartographie',
      this.trackingResponse.parcel.parcelNumber
    );
    this.mapDialog.open(DeliveryMapComponent, {
      disableClose: true,
      panelClass: 'delivery-map-dialog',
      data: {
        "title": "Carte",
        "tag": this.tag,
        "openTime": openTime,
        "deliveryAdresse" : this.deliveryAdresse,
        "parcelUuid": this.trackingResponse.parcel.parcelUuid,
        "responseTpr":this.responseTpr,
        "shipperId": this.accountNum,
        "cab": this.trackingResponse.parcel.parcelNumber
      }
    });
  }

  isMobile() {
    var width = window.outerWidth;
    if (width < 600 ) {
      return true;
    }
    return false;
  }

  getProgression(): Number {
    switch (this.lastEventActive.stepId) {
      case 1: return 0;
      case 2: return 25;
      case 3: return 50;
      case 4: return 75;
      case 5: return 100;
      default:
        return 0;
    }
  }
}
